import { Log } from 'probe.gl';
export default new Log({
  id: 'luma'
}).enable();
//# sourceMappingURL=log.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/utils/log.js
// module id = 164
// module chunks = 0